import ImageLoading from './ImageLoading.vue';
import LoadingBar from './LoadingBar.vue';
import LoadingIcon from './LoadingIcon.vue';
import PageLoading from './PageLoading.vue';

export { ImageLoading, LoadingBar, LoadingIcon, PageLoading };
